import React from 'react';
import CheckboxTree from 'react-checkbox-tree';
import {
  changeMapLayer,
  disableMapLayer,
} from '../../../redux/actions/map.action';
import { connect } from 'react-redux';
import { showMapLayer } from '../../../redux/actions/menu.action';
import { message } from 'antd';

class MapLayerQHCT extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked_LopDuLieu: [],
      expanded_LopDuLieu: [],
      isDisableLopNen: false,
    };

    this.LopDuLieu = ['QuyHoachChiTiet'];

    this.TreeLopDuLieu = [
      {
        label: 'Vùng/Khu dự án',
        value: '500',
        children: [
          {
            label: 'Dự án',
            value: 'QHCT_Polygon',
          },

          // {
          //   label: 'Mặt bằng dạng Line',
          //   value: 'QHCT_Line',
          // },

          {
            label: 'Ranh giới Vùng/Khu dự án',
            value: 'QHCT_RanhGioi',
          },
        ],
      },

      // {
      //   label: 'Quy hoạch phân khu 1/5000',
      //   value: '5000',
      //   children: [
      //     {
      //       label: 'Mặt bằng dạng Polygon',
      //       value: 'QHPK_Polygon',
      //     },

      //     {
      //       label: 'Mặt bằng dạng Line',
      //       value: 'QHPK_Line',
      //     },

      //     {
      //       label: 'Ranh giới quy hoạch',
      //       value: 'QHPK_RanhGioi',
      //     },
      //   ],
      // },

      // {
      //   label: 'Quy hoạch chung 1/10000',
      //   value: '10000',
      //   children: [
      //     {
      //       label: 'Mặt bằng dạng Polygon',
      //       value: 'QHC_Polygon_All',
      //       children: [
      //         {
      //           label: 'Quy Hoạch',
      //           value: 'QHC_Polygon',
      //         },

      //         {
      //           label: 'Hiện trạng',
      //           value: 'QHC_HienTrang',
      //         },
      //       ],
      //     },

      //     {
      //       label: 'Mặt bằng dạng Line',
      //       value: 'QHC_Line',
      //     },

      //     {
      //       label: 'Ranh giới quy hoạch',
      //       value: 'QHC_RanhGioiQuyHoach',
      //     },
      //   ],
      // },

      // {
      //   label: 'Kiến trúc',
      //   value: 'KienTruc',
      // },
    ];
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.checked_LopDuLieu !== this.state.checked_LopDuLieu) {
      if (this.state.checked_LopDuLieu.length > 1) {
        message.open({
          content: (
            <div
              style={{
                width: '650px',
                display: 'flex',
              }}
            >
              <i
                className='fas fa-info-circle'
                style={{
                  fontSize: '16px',
                  marginRight: '10px',
                  color: '#1F86EB',
                  marginTop: '5px',
                }}
              />

              <div
                style={{
                  fontSize: '14px',
                  fontFamily: 'sans-serif',
                  fontFamily: 'Roboto',
                  textAlign: 'justify',
                }}
              >
                Khi mở nhiều hơn 1 lớp dữ liệu, hệ thống sẽ ưu tiên hiển thị
                thông tin lớp dữ liệu theo thứ tự: Quy hoạch chi tiết 1/500, Quy
                hoạch phân khu 1/5000, Quy hoạch chung 1/10000, Kiến trúc
              </div>
            </div>
          ),
        });
      }
    }
  }

  componentDidMount() {
    this.props.disableMapLayer(false);
    if (this.props.isEnableLayer) {
      let listLopNen = [
        'RanhGioiDiaChinh',
        'ThongTinDiaChinh',
        'RanhGioiHanhChinh',
        'BanDo64',
        'BienSoNha',
      ];
      let checked_LopNen = [];
      let checked_LopDuLieu = [];

      this.props.isEnableLayer.forEach((e) => {
        if (listLopNen.includes(e)) {
          checked_LopNen.push(e);
        } else {
          checked_LopDuLieu.push(e);
        }
      });
      this.setState({
        checked_LopNen,
        checked_LopDuLieu,
      });
    }
  }

  SetStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  async onCheckLopDuLieu(checked) {
    await this.SetStateAsync({ checked_LopDuLieu: checked });
    this.getAllChecked();
  }

  onExpandLopDuLieu(expanded) {
    this.setState({ expanded_LopDuLieu: expanded });
  }

  getAllChecked() {
    let list = ['LopDuLieu', 'LopNen'];
    let checkList = [];
    list.forEach((e) => {
      this.state[`checked_${e}`].forEach((o) => {
        checkList.push(o);
      });
    });
    this.props.changeMapLayer(checkList);
    return checkList;
  }

  render() {
    return (
      <div className='map-layer'>
        <div className='title-1'>LỚP DỮ LIỆU</div>

        <CheckboxTree
          checked={this.state.checked_LopDuLieu}
          expanded={this.state.expanded_LopDuLieu}
          iconsClass='fa5'
          disabled={this.props.isDisableLayer}
          nodes={this.TreeLopDuLieu}
          onCheck={(e) => this.onCheckLopDuLieu(e)}
          onExpand={(e) => this.onExpandLopDuLieu(e)}
          showNodeIcon={false}
          icons={{
            check: (
              <i className='fas fa-check-square' style={{ color: '#1F86EB' }} />
            ),
            uncheck: <i className='far fa-square' />,
          }}
        />
        <div>
          {/* <i
            className="fas fa-chevron-circle-left icon-resize"
            style={{ fontSize: "24px", left: `${this.props.isShowMenu ? "598px" : "370px"}` }}
            onClick={() => {
              this.props.showMapLayer(false);
            }}
          ></i> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isEnableLayer: state.map.isEnableLayer,
    isDisableLayer: state.map.isDisableLayer,
  };
};

const mapDispatchToProps = {
  changeMapLayer: changeMapLayer,
  disableMapLayer: disableMapLayer,
};

export default connect(mapStateToProps, mapDispatchToProps)(MapLayerQHCT);
